import type { PaymentParams } from '@openeducation/pp-rn-shared-types';

import { atomWithAsyncStorage } from '../utils';
export const paymentInfoAtom = atomWithAsyncStorage<PaymentParams | null>(
  'payment-info',
  null
);
